import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from '@services/toast.service';

@Component({
  selector: 'app-toast-host',
  template: `
    <div class="toast-host" role="status" aria-live="polite">
      @for (toast of toastService.messages(); track toast.id) {
        <div class="toast">
          {{ toast.message }}
        </div>
      }
    </div>
  `,
  styles: [
    `
      .toast-host {
        position: fixed;
        top: 16px;
        right: 16px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        z-index: 200;
      }

      .toast {
        min-width: 220px;
        max-width: 320px;
        padding: 14px 18px;
        border-radius: 16px;
        background: rgba(27, 46, 32, 0.9);
        color: var(--color-toast-text);
        font-size: 0.85rem;
        letter-spacing: 0.02em;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18);
        animation: toast-in 0.25s ease-out;
      }

      @keyframes toast-in {
        from {
          transform: translateY(-8px);
          opacity: 0;
        }
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }

      @media (max-width: 600px) {
        .toast-host {
          left: 16px;
          right: 16px;
        }

        .toast {
          width: 100%;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastHost {
  protected readonly toastService = inject(ToastService);
}
